import { useLocation } from "react-router-dom";
import BatchProcessing from "./batchdetails";

export const BatchProcessingPage = () => {
    const location = useLocation();
    return <BatchProcessing key={location.key} />
 }
